import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let echoInstance = null;

export default echoInstance ??= new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: 'eu',
  forceTLS: true,
});

export const leaveChannel = (channelName) => {
  echoInstance.leave(channelName);
};
